import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormFullNameInput.module.css";
import {TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";

const FormFullNameInput = ({label, initValues, widthLimit, controlRef}) => {

    const inputRef1 = useRef(null);
    const inputRef2 = useRef(null);
    const inputRef3 = useRef(null);

    const [errorMessage1, setErrorMessage1] = useState("")
    const [errorMessage2, setErrorMessage2] = useState("")
    const [errorMessage3, setErrorMessage3] = useState("")

    const inputRefs = [inputRef1, inputRef2, inputRef3];
    const errorMessages = [errorMessage1, errorMessage2, errorMessage3];
    const setErrorMessageFuncs = [setErrorMessage1, setErrorMessage2, setErrorMessage3];

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getFirstName: () => getText(inputRef1),
                getMiddleName: () => getText(inputRef2),
                getLastName: () => getText(inputRef3),
                validateFirstNameNotEmpty: errorMessage => validateNotEmpty(inputRef1, errorMessage),
                validateMiddleNameNotEmpty: errorMessage => validateNotEmpty(inputRef2, errorMessage),
                validateLastNameNotEmpty: errorMessage => validateNotEmpty(inputRef3, errorMessage),
                validateLengths: validateLengths,
            };
        }
    })

    function getText(inputRef) {
        return inputRef.current.value.trim();
    }

    function setErrorMessage(inputRef, msg) {
        if (inputRef === inputRef1)
            setErrorMessage1(msg);
        if (inputRef === inputRef2)
            setErrorMessage2(msg);
        if (inputRef === inputRef3)
            setErrorMessage3(msg);
    }

    function validateNotEmpty(inputRef, errorMessage) {
        if (getText(inputRef).length > 0)
            return true;
        setErrorMessage(inputRef, errorMessage);
        return false;
    }

    function validateLength(inputRef, maxLength, errorMessage = undefined) {
        const textLength = getText(inputRef).length;
        if (textLength <= maxLength)
            return true;
        setErrorMessage(inputRef,errorMessage ?? `Слишком длинная строка! (нужно укоротить на ${textLength - maxLength} символ(ов))`);
        return false;
    }

    function validateLengths(maxLength) {
        return validateLength(inputRef1, maxLength) && validateLength(inputRef2, maxLength) && validateLength(inputRef3, maxLength);
    }

    function renderInputRow(rowLabel, dataIndex) {
        return (
            <div className={cl.inputRow}>
                <span className={cl.inputRowLabel}>{rowLabel}</span>
                <TextField
                    type="text"
                    variant="outlined"
                    hiddenLabel
                    inputRef={inputRefs[dataIndex]}
                    defaultValue={initValues[dataIndex]}
                    error={errorMessages[dataIndex] !== ""}
                    helperText={errorMessages[dataIndex]}
                    sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                    slotProps={{
                        htmlInput: {
                            sx: {backgroundColor: "white", borderRadius: "4px"}
                        }
                    }}
                    onChange={() => {
                        if (errorMessages[dataIndex])
                            setErrorMessageFuncs[dataIndex]("")
                    }}
                />
            </div>
        );
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={"Если известен лишь псевдоним, укажите его в поле 'имя'"}
            />
            <div className={cl.inputRows}>
                {renderInputRow("Ф", 2)}
                {renderInputRow("И", 0)}
                {renderInputRow("О", 1)}
            </div>
        </div>
    );
};

export default FormFullNameInput;